
import Modal from '@/components/common/Modal.vue'
import ConfirmDlg from '@/components/common/ConfirmDlg.vue'
import ClientAdd from '@/components/ClientAdd.vue'
import InputWrapper from '@/components/common/InputWrapper.vue'
import InputText from '@/components/common/InputText.vue'
import InputPassword from '@/components/common/InputPassword.vue'
import InputCheck from '@/components/common/InputCheck.vue'

import { useApi } from '@/lib/api'
import { errorMap } from '@/lib/filters'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { GlobalState } from '@/lib/types'
import Nav from '@/components/Nav.vue'

export default defineComponent({
  components: { InputWrapper, InputText, InputCheck, Nav, Modal, ClientAdd, ConfirmDlg, InputPassword },
  setup() {
    const _api = useApi()
    const _store = useStore<GlobalState>()
    const _inst = getCurrentInstance()
    const data = ref({})
    const certData = ref({})
    const sipassData = ref({})
    const dlgClient = ref()
    const dlgClientRemove = ref()
    const chk = ref(true)
    const sifData = ref({ clientList: [], clientListAll: [] })
    const userData = ref({ email: _store.state.user.email, notifications: _store.state.user.notifications })

    const updatePassword = async () => {
      const res = await _api.post<any>('passwordWrite', data.value)
      if (res.status === 200) {
        data.value = {}
        _store.commit('userChangePassword')
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Geslo spremenjeno.' })
      }
    }

    const changeCert = async () => {
      await _api.get('changeCert')
      _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'E-sporočilo poslano.' })
    }

    const getSifData = async () => {
      // let res = await _api.cache.get<any>('sifList?type=client')
      // sifData.value.clientList = res.data

      const res = await _api.get<any>('clientList?all=1')
      sifData.value.clientListAll = res.data
    }

    const getLoginData = async () => {
      if (!_store.state.user.sipass) {
        const res = await _api.axios.get<any>('cert')
        if (res.status === 200) {
          certData.value = res.data.cert
        }
      } else {
        const res = await _api.axios.get<any>('sipassInfo')
        if (res.status === 200) {
          sipassData.value = res.data
        }
      }
    }

    const clientAdded = async () => {
      dlgClient.value.close()
      _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Naročnik dodan.' })

      const res = await _api.get<any>('clientList?all=1')
      sifData.value.clientListAll = res.data
    }

    const submitNotifications = async () => {
      const res = await _api.post<any>('userNotificationsWrite', userData.value)
      if (res.status === 200) {
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Podatki shranjeni.' })
        _store.state.user.notifications = userData.value.notifications
        _store.state.user.email = userData.value.email
      }
    }

    const removeClient = async (e: any) => {
      if (e) {
        await _api.get('clientDelete?id=' + dlgClientRemove.value.tag, _store.state.user)
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Naročnik odstranjen.' })

        const res = await _api.get<any>('clientList?all=1')
        sifData.value.clientListAll = res.data
      }
    }

    getLoginData()
    getSifData()

    return { sifData, dlgClient, dlgClientRemove, errorMap, data, updatePassword, changeCert, certData, sipassData, clientAdded, submitNotifications, removeClient, chk, userData }
  }
})
